module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "preview preview--event",
    class: _vm.classes
  }, [_c('safe-link', {
    staticClass: "preview__link preview__link--event",
    attrs: {
      "url": _vm.evt.link
    }
  }, [(_vm.evt.image) ? _c('img', {
    staticClass: "preview__img",
    attrs: {
      "src": _vm.image,
      "alt": _vm.evt.image.alt
    }
  }) : _vm._e(), _vm._v(" "), _c('hgroup', {
    staticClass: "preview__hgroup"
  }, [_c('h4', {
    staticClass: "preview__type",
    class: ("preview__type--" + (_vm.type.tag))
  }, [_vm._v(_vm._s(_vm.type.name))]), _vm._v(" "), _c('h3', {
    staticClass: "preview__event"
  }, [_vm._v(_vm._s(_vm.name))])])]), _vm._v(" "), _c('safe-link', {
    staticClass: "preview__content",
    attrs: {
      "url": _vm.evt.link
    }
  }, [_c('h5', {
    staticClass: "preview__date",
    domProps: {
      "innerHTML": _vm._s(_vm.date)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "preview__description"
  }, [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('span', {
    staticClass: "preview__plus"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c56fca62!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/events/EventPreview.vue
// module id = 653
// module chunks = 1